import { ogImage, OG_SIZE } from "@/lib/og";

export const alt = "About Quto AI — The AI Agents Agency";
export const size = OG_SIZE;
export const contentType = "image/png";

export default function Image() {
  return ogImage({ title: "About Quto AI", eyebrow: "The AI Agents Agency" });
}
